import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
@Component({
  selector: 'cipx-drawer-header',
  templateUrl: './drawer-header.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    MatIconButton,
  ]
})
export class DrawerHeaderComponent {
  @Input() title = '';
  @Input() showCloseButton = false;
  @Input() showCollapseButton = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() collapseEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Input() showBackButton = false;
}
